// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroCircleOutlinedSvg from "@fishx/icons-svg/es/asn/EuroCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var EuroCircleOutlined = function EuroCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleOutlinedSvg
  }));
};

EuroCircleOutlined.displayName = 'EuroCircleOutlined';
export default React.forwardRef(EuroCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EuroCircleOutlined.js
// module id = 2611
// module chunks = 0